/* unplugin-vue-components disabled */import script from "./xgPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./xgPlayer.vue?vue&type=script&setup=true&lang=js"

import "./xgPlayer.vue?vue&type=style&index=0&id=a2a6318c&lang=css"

const __exports__ = script;

export default __exports__